import * as React from 'react'
import moment from 'moment'
import { DatePicker as AnDatePicker } from 'antd'
import './datePickerStyles.css';
import fieldProps from './fieldProps'
import {CalendarIcon} from "../../../../config/icons";

const dateFormat = 'DD/MM/YYYY'
// const monthFormat = 'YYYY/MM';
const formater = (m, format) => format === 'X' ? parseInt(m.format(format),10) : m.format(format)

@fieldProps
export default class Datepicker extends React.Component {
  render() {
    const { onChange, format = 'YYYY-MM-DD', value, disabled } = this.props

    // todo: verificar el format del value (format === 'X' ? 'X': undefined)  temporaneo



    return (
      <AnDatePicker
        suffixIcon={<CalendarIcon />}
        className={"date-picker-left"}
        onChange={m => onChange(m ? formater(m, format) : m)}
        value={value ? moment(value, format === 'X' ? 'X': undefined) : null}
        format={dateFormat}
        disabled={disabled}
        placeholder={''}
      />
    )
  }
}
